import * as R from 'ramda';

export const isNilOrEmpty = R.either(R.isNil, R.isEmpty);

export const isPropNilOrEmpty = R.propSatisfies(R.either(R.isEmpty, R.isNil));

export const useWhen = (fn, useTrue, useFalse = null) => props =>
  R.ifElse(R.equals(true), R.always(useTrue), R.always(useFalse))(fn(props));

export const filterBy = pred =>
  R.pipe(
    R.toPairs,
    R.filter(R.apply(pred)),
    R.fromPairs
  );

export const capitalize = R.compose(
  R.join(''),
  R.juxt([
    R.compose(
      R.toUpper,
      R.head
    ),
    R.tail,
  ])
);

export const extract = R.curry((selectors, item) => R.map(selectFn => selectFn(item), selectors));

export const extractProps = R.curry((selectors, item) =>
  R.mapObjIndexed((selectFn, prop) => selectFn(item[prop]), selectors)
);
